import request from "@/utils/oms-request";

export const clearPurchaseOrderClaimInfo = (id) =>
    request({
        url: `/claim_form/purchase-order/${id}/claimInfo/clear`,
        method: "PUT",
    });

export const cancelWriteOff = (id) =>
    request({
       url: `/claim_form/${id}/cancel-write-off`,
       method: "PUT",
    });